// extracted by mini-css-extract-plugin
module.exports = {"resultProgressBar":"styles_resultProgressBar__3onWE","resultProgressBarInner":"styles_resultProgressBarInner__aGB7D","resultProgressPercent":"styles_resultProgressPercent__2A9PQ"};